import { Component, ViewChild, OnInit, Input, ChangeDetectorRef, AfterViewInit, Renderer2, Inject } from '@angular/core';
import { LoginService, Login } from './login/login.service';
import { AbstractLoginStatusListener } from './login/login.status.listener';
import { ConfirmationService, MenuItem, PrimeNGConfig, OverlayOptions } from 'primeng/api';
import { InstanceComponent } from './research/instance/instance.component';
import { InstanceOfCare } from './model/claim/instance_of_care';
import { MatchingComponent } from './encounters/matching/matching.component';
import { MatchSummary } from './model/claim/match_summary';
import { Store } from '@ngrx/store';
import { TcemsService } from './api/tcems.service';
import { ProcedureLookupComponent } from './research/instance/procedure-lookup/procedure-lookup.component';
import { EncounterLookupComponent } from './encounters/encounter-lookup/encounter-lookup.component';
import { selectCurrentUser, selectTwilioReservation, selectTwilioWorkerStatus, selectUserState } from './state/app.state';
import { User, UserState } from './model/util/user';
import { userReducer } from './reducers/api/tcems/globals.reducer';
import { updateUserState } from './actions/api/tcems.actions';
import { ProviderResearchComponent } from './research/providers/provider-research/provider-research.component';
import { environment } from 'src/environments/environment';
import { PhiResult, PhiSearchResult } from './phi/phi-search/phi-search.component';
import { Phi } from './model/phi/phi';
import { TcemsUtilitiesService } from './util/tcems-utilities.service';
import { fromEvent, Subscription } from 'rxjs';
import { delay } from 'rxjs/operators';
import { _USER_RUNTIME_CHECKS } from '@ngrx/store/src/tokens';
import { HomePageComponent } from './base/home-page/home-page.component';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TwilioService } from './services/twilio.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { AppBetaStateService } from './services/app-betastate.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent extends AbstractLoginStatusListener implements OnInit
{
  @ViewChild(HomePageComponent) homePageComponent: HomePageComponent;
  @ViewChild('phiResults') phiResults: OverlayPanel;
  @ViewChild('twilioDiv') twilioButton;

  buttonEvent: PointerEvent = new PointerEvent("click",null);
  showResults: boolean = false;

  loggedIn: boolean = false;
  topMenuModel: MenuItem[];
  sideMenuModel: MenuItem[];

  currentUser$ = this.store.select(selectCurrentUser);
  currentUser : User;

  allowAdminAccess: boolean = false;
  

  currentUserState$ = this.store.select(selectUserState);
  currentUserState : UserState;

  version: string = environment.version;

  // Twilio task router stuff
  
  taskrouterButtonLabel: string;
  taskrouterWhiteLabelAndCid: string;
  taskrouterPopUpColor: boolean;
  taskrouterButtonClass: string;
  phiSearchResults:PhiSearchResult[];

  //Center panel IDs
  HOME_PAGE = 'homepage';
  RESEARCH_PLAN = 'researchplan';
  RESEARCH_PHI = 'researchphi';
  RESEARCH_LOOKUP_INSTANCE = 'lookupinstance';
  RESEARCH_SEARCH_INSTANCE = 'searchinstance';
  RESEARCH_PROCEDURE_LOOKUP = 'procedurelookup';
  ENCOUNTER_MATCH = 'encountermatch';
  ENCOUNTER_LOOKUP = 'encounterlookup';
  UTILITY_TRANSACTION_MANAGER = 'transactionmanager';  
  UTILITY_INVOICE_MANAGER = 'invoicemanager'; 
  UTILITY_COMPANY_MANAGER = 'companymanager';
  RESEARCH_MANAGE_PRACTICE = "researchmanagepractice";
  REPORTS_REPORT_RUNNER = "reportrunner";
  REPORTS_REPORT_VIEWER = "reportviewer";
  REPORTS_REPORT_MANAGER = "reportmanager";

  //Side menu blocks
  SM_RESEARCH = 'research';

  components = {}; 
  visibility = {}; 

  //Home page toggle
  showHomePage: boolean = true;
  chatComponentURI: string = environment.chatURI;

  // Beta features
  betaShowOverride: boolean = environment.betaShowOverride;
  betaActive: boolean = false;
  private betaSub: Subscription = Subscription.EMPTY;

  betaToggle() {
    this.appBetaState.setBetaActive(this.betaActive);
    console.log("Beta active changed to: " + this.betaActive);
  }

  workerStatus$ = this.store.select(selectTwilioWorkerStatus);
  reservation$ = this.store.select(selectTwilioReservation);

  twilioButtonOptions : MenuItem[]; 

  CPT_NONE: string = "none";
  CPT_SINGLE: string = "single";
  CPT_SPLIT_2_10: string = "split_2_10";

  centerPanelType: string = this.CPT_NONE;

  loginStatusChange(status: Login) 
  {
      this.loggedIn = status.loggedIn;
  }
  
  title = 'HEMI';

  constructor(private loginService: LoginService,
    private store: Store, 
    private tcemsService: TcemsService, 
    private util: TcemsUtilitiesService,
    private cdr: ChangeDetectorRef,
    private twilioService: TwilioService,
    public twilio: TwilioService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private primengConfig: PrimeNGConfig,
    private appBetaState: AppBetaStateService
    ) 
    { 
  
      super(loginService);
      this.router.routeReuseStrategy.shouldReuseRoute = () => false
      //Handle routes directly into an encounter
      this.route.paramMap.
      subscribe
      (
        (params: ParamMap) => 
        {
          let id = +params.get('id');
          if(id != 0)
          {
            console.log(id);
          }
          
        }
      )
      this.appBetaState.betaActive$.subscribe(value => this.betaActive = value);
    }



  ngOnInit() : void
  {
    super.ngOnInit();

    //And our default side menu model

    // Load HOME_PAGE as default
    this.centerPanelType = this.CPT_SINGLE;
    this.changeCenterView(this.HOME_PAGE);

    //Pay attention to the routes that get us here
    // this.route.queryParams.subscribe(params => {
    //   this.changeCenterView(params['main_view']);
    // });


    //Router connections
    //The last entry in the path is what we want to show in our main view
    //There could also be a parameter available to us
    //Available routes:
    // /encounter?[id]


    this.workerStatus$.subscribe
    (
      s =>
      {
        this.updateButton(s);
      }
    )

    this.reservation$.subscribe
    (
      r =>
      {
        let reservationStatus = r.reservationStatus?.toLowerCase();

        if( ( r.reservation!= null ) && ( ( reservationStatus == "created" ) || ( reservationStatus == "accepted" ) || ( r.reservation.reservationStatus == "pending" ) ) )
        {
          if( r.reservation.task.attributes.type == "CHAT" && reservationStatus == "created" )
          {
            if ( r.reservation.task.attributes.memberId != "" ) {
              this.phiSearch({'query':r.reservation.task.attributes.memberId});
              this.showResults = true;
            }
            this.updateButton("Chat");
            this.playChime();
          }
          else if( r.reservation.task.attributes.type == "OUTBOUND")
          {
            // Do nothing
          }
          else if(r.reservation.task.attributes.type == "VOICE")
          {
            this.updateButton("Ringing");
            this.showResults = true;
            var fromNumber = r.reservation.task.attributes.from.replace("+1","");
            this.phiSearch({'query':fromNumber});
            switch( fromNumber ) {
              case "266696687":  // ANONYMOUS
              case "7378742833":  // RESTRICTED
              case "2562533":  // BLOCKED
              case "8656696":  // UNKNOWN
              case "86282452253":  // UNAVAILABLE
                fromNumber = "[UNKNOWN]";
                break;
              default:
                fromNumber = fromNumber.substr( 0,3 ) + "-" + fromNumber.substr( 3,3 ) + "-" + fromNumber.substr( 6 );
                break;
            }
            this.taskrouterWhiteLabelAndCid = r.reservation.task.attributes.program.toUpperCase() + ": " + fromNumber;
            if ( r.reservation.task.attributes.program != 'hpi_pa' ) {
              this.taskrouterPopUpColor = false;
            } else {
              this.taskrouterPopUpColor = true;
            }
          }
        }
        else
        {
          this.showResults = false;
        }
      }
    )


      this.currentUser$.subscribe(
        u => 
        {
          if(u != null)
          {
            this.currentUser = Object.assign(new User(),u); 
            if(u.roles.map(r => r.role).includes("Admin"))
            {
              this.allowAdminAccess = true;
            }

            

            //set up our top model
            this.topMenuModel = this.getTopMenuModel();


          }
        });
        
        this.currentUserState$.subscribe(
          u => 
          {
            if (u==null) return;

            this.currentUserState = Object.assign(new UserState(),u);
          });
        
      //Listen for User State Changes
      let source$ = fromEvent(window, 'storage');
      source$.pipe(delay(2000)).subscribe
      (
        storageEvent =>
        {
          let action = localStorage.getItem('USER_STATE');
          if(action != null)
          {
            //If state has changed, then update...
            if(action != JSON.stringify(this.currentUserState))
              this.store.dispatch({type: updateUserState.type, userState: JSON.parse(action)});
          }
        }
      )


      this.twilioButtonOptions= [
        {label: 'Away', command: () => {this.twilio.MakeWorkerAway();}},
        {label: 'Ready', command: () => {this.twilio.MakeWorkerReady();}},
        {label: 'Desk', command: () => {this.twilio.MakeWorkerDesk(); }},
        {label: 'Busy', command: () => {this.twilio.MakeWorkerBusy(); }},
        {label: 'Vacation', command: () => {this.twilio.MakeWorkerVacation(); }}
      ];
    
      this.betaSub = this.appBetaState.betaActive$.subscribe(value => this.betaActive = value);

  }

  ngOnDestroy(): void {
    if (this.betaSub) {
      this.betaSub.unsubscribe();
    }
  }

  taskrouterButtonClick() : void {
    switch( this.taskrouterButtonLabel ) {
      case 'Away':
        this.twilio.MakeWorkerReady();
        break;
      case 'Busy':
        this.twilio.MakeWorkerAway();
        break;
      case 'Chat':
        this.twilio.MakeWorkerAcceptReservation();
        break;
      default:
        this.twilio.MakeWorkerAway();
    }
  }

  taskrouterDropDownClick() : void 
  {
    
  }

  //Handle the login event
  login(event)
  {
    
  }

  logout()
  {
    this.loginService.logout();
  }

  changeCenterView(context: string)
  {
      Object.keys(this.visibility).forEach( v => this.visibility[v] = false)
      this.visibility[context] = true;  
  }

  getSideMenuModel(context: string): MenuItem[]
  {
    switch (context)
    {
      case this.SM_RESEARCH:
        return [
          {
            label: 'Plan Research',
            items: [
                      {label: 'Lookup Plans', command: (event) => { this.router.navigate(['research/plan']) }}
                  ]
          },
          {
            label: 'Member Research',
            items: [
                    {label: 'Lookup Members', command: (event) => { this.router.navigate(['research/member']) }}
                  ]
          },
          {
            label: 'Instance Research',
            items: [
                    {label: 'Lookup Instances', command: (event) => { this.router.navigate(['research/instance/instance']) }},
                    {label: 'Search Instances', command: (event) => { this.router.navigate(['research/instance/search'])}},
                    {label: 'Procedure Lookup', command: (event) => { this.router.navigate(['research/procedurelookup']) }}
                  ]
          },
          {
            label: 'Provider Research',
            items: 
            [
              {label: 'Manage Practices', command: (event) => {this.router.navigate(['research/provider']) }}
            ]
          }
        ]
      default:
        return [] as MenuItem[];
    }

  }

  getTopMenuModel(): MenuItem[]
  {    

    return [
        {label: 'Home', icon: 'pi pi-fw pi-home',command: (event) => { this.centerPanelType = this.CPT_SINGLE; this.router.navigate(['home']); } },
        {label: 'Encounters', icon: 'pi pi-folder-open', 
          items: 
                [
                  {label: 'Matching' ,command: (event) => { this.centerPanelType = this.CPT_SINGLE; this.router.navigate(['research/matching']) }},
                  {label: 'Encounter Lookup', command: (event) => {this.centerPanelType = this.CPT_SINGLE; this.router.navigate(['encounter/lookup'])}}
                ]
         },
        {label: 'Research', icon: 'pi pi-search-plus', command: (event) => { this.centerPanelType = this.CPT_SPLIT_2_10;  this.sideMenuModel = this.getSideMenuModel(this.SM_RESEARCH); this.changeCenterView('');}},
        {label: 'Reports', icon: 'pi pi-chart-bar', 
          items:
                [
                  {label: 'Report Definition Manager', command: (event) => { this.centerPanelType = this.CPT_SINGLE;  this.router.navigate(['reports/definereports']) }},
                  {label: 'Run Reports', command: (event) => { this.centerPanelType = this.CPT_SINGLE;  this.router.navigate(['reports/runreports']) }},
                  {label: 'View Reports', command: (event) => { this.centerPanelType = this.CPT_SINGLE;  this.router.navigate(['reports/viewreports']) }}
                ]},
        {label: 'Utilities', icon: 'pi pi-briefcase',
          items:
                [
                  {label: 'Transaction Manager', disabled: !this.allowAdminAccess, command: (event) => { this.centerPanelType = this.CPT_SINGLE; this.router.navigate(['utility/transactionmanager']) }},
                  {label: 'Invoice Manager', disabled: !this.allowAdminAccess, command: (event) => { this.centerPanelType = this.CPT_SINGLE; this.router.navigate(['utility/invoicemanager'])}},
                  {label: 'Company Manager', command: (event) => { this.centerPanelType = this.CPT_SINGLE; this.router.navigate(['utility/companymanager']) }},
                  {label: 'Mass Email Manager', disabled: !this.allowAdminAccess, command: (event) => { this.centerPanelType=this.CPT_SINGLE; this.router.navigate(['utility/massemailmanager'])}},
                  {label: 'Job Manager', disabled: !this.allowAdminAccess, command: (event) => { this.centerPanelType=this.CPT_SINGLE; this.router.navigate(['utility/jobmanager'])}},
                  {label: 'HomePage_v2', disabled: !this.allowAdminAccess, command: (event) => {this.centerPanelType = this.CPT_SINGLE; this .router.navigate(['home_v2'])}}
                ] 
        
        },
        {label: 'Speed Dial', icon: 'pi pi-phone', 
          items:
                [
                  {label: 'Access Sports Medicine', icon: 'pi pi-stopwatch', command: (event) => { this.hemiOutboundCall('6037757575',this.currentUser.hemiPhoneNumber,'Access_Sports')  }},
                  {label: 'Derry Imaging', icon: 'pi pi-images', command: (event) => { this.hemiOutboundCall('6035371363',this.currentUser.hemiPhoneNumber,'Derry_Img')  }},
                  {label: 'Rayus Imaging', icon: 'pi pi-images', command: (event) => { this.hemiOutboundCall('8007344132',this.currentUser.hemiPhoneNumber,'Rayus_Img')  }},
                  {label: 'Shields MRI', icon: 'pi pi-images', command: (event) => { this.hemiOutboundCall('8002584674',this.currentUser.hemiPhoneNumber,'Shields_MRI')  }},
                  {label: 'Tellica Imaging', icon: 'pi pi-images', command: (event) => { this.hemiOutboundCall('6037824330',this.currentUser.hemiPhoneNumber,'Tellica_Img')  }},
                  {label: 'HPHC Member Services', icon: 'pi pi-id-card', command: (event) => { this.hemiOutboundCall('8883334742',this.currentUser.hemiPhoneNumber,'HP_Mbr_Svc')  }},
                ]},
        {label: 'Logout', icon: 'pi pi-power-off', command: (event) => { this.logout()}}
      ] as MenuItem[];
  }
  
  playChime() : void {
    let audio = new Audio();
    audio.src = "../assets/sounds/chime.mp3";
    audio.load();
    audio.play();
  }
  
  updateButton( activityName) : void {

    this.taskrouterButtonLabel = activityName;

    switch ( activityName )
    {
      case 'Away':
        this.taskrouterButtonClass = "p-button-danger";
        this.taskrouterWhiteLabelAndCid = "";
        this.taskrouterPopUpColor = false;
        this.phiSearchResults = null;
        break;
      case 'Ready':
        this.taskrouterButtonClass = "p-button-success";
        this.taskrouterWhiteLabelAndCid = "";
        this.taskrouterPopUpColor = false;
        this.phiSearchResults = null;
        break;
      case 'Call':
        this.taskrouterButtonClass = "p-button-warning";
        break;
      case 'Chat':
        this.taskrouterButtonClass = "p-button-help";
        break;
      case 'Outbound':
        this.taskrouterButtonClass = "p-button-secondary";
      case 'Busy':
        this.taskrouterButtonClass = "p-button-secondary";
        break;
      case "WrapUp":
        this.taskrouterButtonClass = "p-button-info";
        break;
      case "Desk":
        this.taskrouterButtonClass = "p-button-info";
        break;
      default:
        this.taskrouterButtonClass = "p-button-secondary";
        break;
    }

    
    //this.cdr.detectChanges();

  }

  showPhiResults(event)
  {
    console.log(event)
    this.showResults = !this.showResults;
  }

  phiSearch($event)
  {
    let q = $event.query;
    // console.log("Search:" + q);

    //Depending on the search string, we want to build our results a bit differently
    //Numbers mean that we're looking at member ids and/or encounter ids
    //strings mean that we're looking at member ids and/or phi

    let allPromises: Promise<PhiSearchResult[]>[] = [];

    if (q == null || q.length == 0 ) { return; } // empty query
    
      // Do Phi
      allPromises = [...allPromises, this.tcemsService.searchForPhi({query: q}).toPromise()
      .then
      (
        results =>
          {
            // console.log(results);
            return results.filter(p => (Object.assign(new Phi(),p).isSubscriber)).map
            (
              p =>
              {
                let phiResult = new PhiResult();
                phiResult.result = p;
                phiResult.phiId = p.phiId;
                return phiResult;
              }
            );
          }
      )
      .catch
      (
        error =>
        {
          console.log('PHI Search Failed: ' + error);
          // this.phiSearchResults = [];
          return null;
        }
      )];

    // Wait til we get everything back
    Promise.all(allPromises).then
    (
      //Set up our list of suggestions

      result =>
      {
        let flatResults:PhiSearchResult[] = [];
        result.forEach( subResult => {if (subResult != null) flatResults = [...flatResults, ...subResult]});
        this.phiSearchResults = [... flatResults];
        console.log(this.phiSearchResults);
      }
    )
  }

      hemiOutboundCall(to:string,callerId:string,encounterId:string):void {
    const url = `https://hemicallrouting-2700.twil.io/hemiOutboundCall?ext=${encodeURIComponent(this.currentUser.extNumber)}&from=${encodeURIComponent(this.currentUser.twilioContactUri)}`
      + `&to=${encodeURIComponent(to)}&callerId=${encodeURIComponent(callerId)}&encounterId=${encodeURIComponent(encounterId)}&workerName=${encodeURIComponent(this.currentUser.username)}`
    fetch(url,{method:'GET',keepalive:true,cache:'no-store'})
    .catch(() => {});
  }


}
